import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/not-found.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/svgs/errorPage404.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ButtonAnimated/ButtonAnimated.js");
